import { useState, useEffect } from 'react';

function useSmartPhone() {
  const [isSmartPhone, setIsSmartPhone] = useState(false);

  useEffect(() => {
    const checkIfSmartPhone = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const isMobile = /iphone|ipad|ipod|android|blackberry|windows phone/i.test(userAgent);
      setIsSmartPhone(isMobile);
    };

    checkIfSmartPhone();

    // Add event listener to update state if the window is resized
    window.addEventListener('resize', checkIfSmartPhone);

    // Clean up by removing event listener on component unmount
    return () => {
      window.removeEventListener('resize', checkIfSmartPhone);
    };
  }, []);

  return isSmartPhone;
}

export default useSmartPhone;
